import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { getDistrictUrl } from '../../utils/domainUtils';
import '../superadmin/DistrictsList.css';

const RegistrationCodesList = () => {
  const { user } = useAuth();
  const [codes, setCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [editCode, setEditCode] = useState(null);
  const [editFormData, setEditFormData] = useState({});

  useEffect(() => {
    fetchCodes();
  }, []);

  const fetchCodes = async () => {
    try {
      const response = await axios.get('/api/registration-codes/district');
      setCodes(response.data);
    } catch (error) {
      console.error('Failed to fetch codes:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/registration-codes/${id}`);
      setCodes(codes.filter(c => c.id !== id));
      setDeleteConfirm(null);
    } catch (error) {
      console.error('Failed to delete code:', error);
      alert('Failed to delete registration code');
    }
  };

  const handleEdit = (code) => {
    setEditCode(code.id);
    setEditFormData({
      code: code.code,
      description: code.description,
      is_active: code.is_active
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`/api/registration-codes/${editCode}`, editFormData);
      setEditCode(null);
      fetchCodes();
    } catch (error) {
      console.error('Failed to update code:', error);
      alert(error.response?.data?.error || 'Failed to update registration code');
    }
  };

  const getRegistrationUrl = (code) => {
    const hostname = window.location.hostname;
    if (hostname.includes('localhost')) {
      return `${window.location.origin}/register?subdomain=${code.subdomain || 'test'}`;
    }
    return `${getDistrictUrl(code.subdomain || 'your-subdomain')}/register`;
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="districts-list">
      <div className="page-header">
        <h2>Registration Codes</h2>
        <Link to="/district-admin/registration-codes/add" className="btn-primary">Add Registration Code</Link>
      </div>

      {deleteConfirm && (
        <div className="modal-overlay" onClick={() => setDeleteConfirm(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h3>Delete Registration Code</h3>
            <p>Are you sure you want to delete this registration code? Parents will no longer be able to use it to register.</p>
            <div className="modal-actions">
              <button onClick={() => handleDelete(deleteConfirm)} className="btn-danger">Delete</button>
              <button onClick={() => setDeleteConfirm(null)} className="btn-secondary">Cancel</button>
            </div>
          </div>
        </div>
      )}

      <table className="data-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Description</th>
            <th>Status</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {codes.length === 0 ? (
            <tr>
              <td colSpan="5" style={{ textAlign: 'center' }}>No registration codes found</td>
            </tr>
          ) : (
            codes.map(code => (
              <tr key={code.id}>
                {editCode === code.id ? (
                  <>
                    <td>
                      <input
                        type="text"
                        value={editFormData.code}
                        onChange={(e) => setEditFormData({...editFormData, code: e.target.value})}
                        style={{ width: '100%', padding: '0.5rem' }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={editFormData.description || ''}
                        onChange={(e) => setEditFormData({...editFormData, description: e.target.value})}
                        style={{ width: '100%', padding: '0.5rem' }}
                      />
                    </td>
                    <td>
                      <label>
                        <input
                          type="checkbox"
                          checked={editFormData.is_active}
                          onChange={(e) => setEditFormData({...editFormData, is_active: e.target.checked})}
                        />
                        {' '}Active
                      </label>
                    </td>
                    <td>{new Date(code.created_at).toLocaleDateString()}</td>
                    <td>
                      <button onClick={handleUpdate} className="btn-edit">Save</button>
                      <button onClick={() => setEditCode(null)} className="btn-secondary">Cancel</button>
                    </td>
                  </>
                ) : (
                  <>
                    <td><strong>{code.code}</strong></td>
                    <td>{code.description || '-'}</td>
                    <td>{code.is_active ? <span style={{ color: '#27ae60' }}>Active</span> : <span style={{ color: '#e74c3c' }}>Inactive</span>}</td>
                    <td>{new Date(code.created_at).toLocaleDateString()}</td>
                    <td className="actions">
                      <button onClick={() => handleEdit(code)} className="btn-edit">Edit</button>
                      <button onClick={() => setDeleteConfirm(code.id)} className="btn-delete">Delete</button>
                    </td>
                  </>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>

      {codes.length > 0 && (
        <div style={{ marginTop: '2rem', padding: '1rem', background: '#f8f9fa', borderRadius: '4px' }}>
          <h3 style={{ marginTop: 0 }}>Registration Instructions</h3>
          <p>Share this information with parents:</p>
          <ol>
            <li>Visit: <code>{getDistrictUrl(user?.subdomain || 'your-subdomain')}/register</code></li>
            <li>Enter one of the active registration codes above</li>
            <li>Complete the registration form</li>
          </ol>
        </div>
      )}
    </div>
  );
};

export default RegistrationCodesList;




